// Postmoro release notes — customer-visible changelog source of truth.
//
// FUTURE UPDATE WORKFLOW
// ----------------------
// For every user-facing deployment, add ONE new release object at the TOP
// of the RELEASES array. Newest ID becomes the "unread" release for every
// user (see useReleaseNotes hook).
//
// Only include CUSTOMER-VISIBLE changes. Never include internal engineering
// or security details.
//
// Item shape:
//   { type: "new" | "improved" | "fixed", text: "Customer-friendly copy." }
//
// Release shape:
//   { id: "YYYY-MM-DD", date: "Month D, YYYY", title: "Postmoro Update", items: [...] }
//
// The `id` must be unique and sortable (ISO-style dates work perfectly).

export const RELEASES = [
  {
    id: "2026-09-01-multi-business",
    date: "September 1, 2026",
    title: "Manage Multiple Businesses in One Account",
    cta: {
      label: "Try Multi-Business",
      to: "/dashboard",
      testid: "whats-new-cta-multi-business",
    },
    items: [
      {
        type: "new",
        text: "Business plans can now manage up to 4 separate business workspaces from one Postmoro account — no need to create separate accounts for each brand or client.",
      },
      {
        type: "new",
        text: "Each workspace has its own Business Profile, AI brand context, posts and calendar, Autopilot settings, media, analytics, and Facebook / Instagram / X / LinkedIn connections. Nothing is shared between businesses.",
      },
      {
        type: "improved",
        text: "Use the workspace switcher at the top of Postmoro to move between businesses at any time.",
      },
      {
        type: "new",
        text: "Business plans include up to 4 total workspaces, including archived workspaces. Available on the Business plan only.",
      },
    ],
  },
  {
    id: "2026-08-29-teams-for-business",
    date: "August 29, 2026",
    title: "Teams for Business",
    items: [
      {
        type: "new",
        text: "Business subscribers can now invite team members to collaborate inside one shared Postmoro workspace.",
      },
      {
        type: "new",
        text: "Team members share access to the workspace's Business features — content, calendar, media library, Autopilot, brand voice, and connected social accounts.",
      },
      {
        type: "new",
        text: "Billing and subscription management stay securely controlled by the workspace owner.",
      },
      {
        type: "improved",
        text: "Invite up to 2 team members from your Business plan (3 total seats: 1 owner + 2 members). Manage your team from Business → Team.",
      },
    ],
  },
  {
    id: "2026-08-27-compliance-live",
    date: "August 27, 2026",
    title: "Organization Compliance is Now Live",
    items: [
      {
        type: "new",
        text: "Postmoro can now check generated and published content against your organization's saved compliance restrictions and required disclosures.",
      },
      {
        type: "new",
        text: "Compliance policies can also be uploaded, reviewed, and approved before they become active.",
      },
      {
        type: "improved",
        text: "Your organization remains responsible for final content review.",
      },
      {
        type: "improved",
        text: "Starter now includes every supported social platform — Facebook, Instagram, X, and LinkedIn — with no platform cap.",
      },
    ],
  },
  {
    id: "2026-08-16-email-updates",
    date: "August 16, 2026",
    title: "Email Updates & Preferences",
    items: [
      {
        type: "new",
        text: "You can now join the Postmoro updates list during account signup or from the Postmoro homepage.",
      },
      {
        type: "new",
        text: "Email Preferences are now available in your account so you can manage your marketing-email subscription anytime.",
      },
      {
        type: "improved",
        text: "Marketing email preferences are kept separate from receipts, password resets, security notices, and other important account emails.",
      },
    ],
  },
  {
    id: "2026-08-16",
    date: "August 16, 2026",
    title: "Postmoro Update",
    items: [
      {
        type: "new",
        text: "24-Hour Support Response Guarantee — every support ticket is reviewed and receives a response within 24 hours or less.",
      },
      {
        type: "new",
        text: "Coming Soon roadmap added to the pricing cards so you can see what's on the way for Starter, Pro, and Business.",
      },
      {
        type: "improved",
        text: "Simplified the Postmoro homepage so key features and pricing are easier to find.",
      },
      {
        type: "fixed",
        text: "Removed a broken pricing-page link from the homepage.",
      },
    ],
  },
];

export const LATEST_RELEASE_ID = RELEASES[0]?.id || null;
